import styles from './Pagination.module.css';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    loading: boolean;
}

export function Pagination({ currentPage, totalPages, onPageChange, loading }: PaginationProps) {
    if (totalPages <= 1) return null;

    return (
        <div className={`${styles.container} ${loading ? styles.loading : ''}`}>
            {/* First Page */}
            <button
                className={styles.btn}
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1 || loading}
            >
                «
            </button>

            {/* Previous */}
            <button
                className={styles.btn}
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1 || loading}
            >
                ‹
            </button>

            <div className={styles.info}>
                <span>{currentPage}</span> / <span>{totalPages}</span>
            </div>

            {/* Next */}
            <button
                className={styles.btn}
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages || loading}
            >
                ›
            </button>

            {/* Last Page */}
            <button
                className={styles.btn}
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages || loading}
            >
                »
            </button>
        </div>
    );
}